import { useEffect, useState } from 'react';
import './Login.css'
// import '../App.css'
import axiosService from '../../lib/Axios';
import { AxiosResponse } from 'axios';
import { iAuthenticationState } from '../../lib/Interfaces/Authentication';
import { store } from '../..';
import { GridContainer, GridItem, Form, Button, Textbox, Pod, Content, Tile } from '../../lib/carbon-ui';
//import {useDispatch} from 'react-redux';

import {useNavigate} from 'react-router-dom';
import { IMessageOrToastOptions, MessageorToastOptionsDefaultState, MessageOrToastWrongUsernameOrPassword, MessageOrToastConnectionError } from '../../Components/MessageOrToast/MessageOrToastOptions';
import { LoginInput } from '../../lib/Interfaces/LoginInput';
import DefaultMessage from '../../Components/MessageOrToast/DefaultMessage';
import { config } from '../../lib/config';

const loginFormInitialState: LoginInput = { userNameOrEmailAddress: '', password: '', returnUrl: '', overrideExisting: false };

export default function Login() {

  // When user clicks logout, will be redirected to Login screen - this just clears auth status and token from central state
  useEffect( () => {
      store.dispatch({type: 'CLEAR_AUTH_STATE_ON_LOGOUT'});
  }, [])

  // Instead of useHistory() for redux-router V6
  const navigate = useNavigate();

  const [loginMessage, setLoginMessage] = useState<IMessageOrToastOptions>(MessageorToastOptionsDefaultState);
  const [loginForm, setLoginForm] = useState<LoginInput>(loginFormInitialState);
  const [isSubmitting, setIsSubmitting] = useState<boolean>(false);


  const handleChange = (e: React.ChangeEvent<HTMLInputElement>) => {
    setLoginMessage(MessageorToastOptionsDefaultState);
    setLoginForm({
      ...loginForm,
      [e.target.id]: e.target.type === 'checkbox' ? e.target.checked : e.target.value
    })
  }

  const handleSubmit = (e: React.FormEvent<HTMLFormElement>) => {
      e.preventDefault();    

      setIsSubmitting(true); //Set submitting state
      setLoginMessage(MessageorToastOptionsDefaultState); //Reset Login Message state
      

      try{
        axiosService.post(`api/v1/token`, {
            username: loginForm.userNameOrEmailAddress,
            password : loginForm.password
        }).then(function(response: AxiosResponse<iAuthenticationState>) {
            //redux stuff
            const {data} = response;
            data.realitexUserName = loginForm.userNameOrEmailAddress
            store.dispatch({type: 'SET_AUTH_STATE_AFTER_POST_LOGIN', authSettings: data});
            if(data.isAuthenticated){
                navigate('/requestpage')
            }
            else
            {
              setLoginMessage(MessageOrToastWrongUsernameOrPassword);
              //displayMessage(error.response.data.error)
            }
            setIsSubmitting(false); //Unset submitting state
            
        }).catch(function(error) {
            //print unauth'd' error if applicable
            console.log(error)
            setLoginMessage(MessageOrToastConnectionError);
            setIsSubmitting(false);
        })       

    }
    catch{
      setLoginMessage(MessageOrToastConnectionError);
      setIsSubmitting(false);
    }
  }

  return (
    <div className="login-wrapper">
      <div className="login-bg" />
      <GridContainer>
        <GridItem alignSelf="stretch" justifySelf="stretch" gridColumn="5 / 9" gridRow="2 / 2" responsiveSettings={[
              {
                maxWidth: '1500px',
                gridColumn: '4 / 10'
              }, {
                maxWidth: '1200px',
                gridColumn: '3 / 11'
              }, {
                maxWidth: '1000px',
                gridColumn: '2 / 12'
              }, {
                maxWidth: '800px',
                gridColumn: '1 / 13'
              }]} >
          <Tile orientation="vertical" className="clear-width">
            {/* <Content align="right">
              <img src={Realitex200Logo} alt="Realitex200"/>
            </Content> */}
            <Content>
              <Pod 
                title="Realitex - MaxOptra Integration" 
                subtitle="Sign in to your account" 
                footer={"Version: "+config.build.version}
                size="none" 
                border={false}>
                <DefaultMessage messageOptions={loginMessage}/>
                <Form
                  buttonAlignment='right'
                  onSubmit={ handleSubmit }
                  stickyFooter footerPadding={{px: 8}}
                  saveButton={
                    <Button 
                      buttonType='primary'
                      type="submit"
                      disabled={isSubmitting || (loginForm.userNameOrEmailAddress.trim() === '' || loginForm.password.trim() === '' ) ? true : false}>
                      {!loginForm.overrideExisting ? 'Login' : 'Continue' }
                    </Button>
                  }
                >
                  { !loginForm.overrideExisting ?
                    <>
                      <Textbox id="userNameOrEmailAddress" label="Username" placeholder="Username" onChange={handleChange}/>
                      <Textbox id="password" type="password" label="Password" placeholder="Password" onChange={handleChange} />
                    </>
                  : null }
                </Form>
              </Pod>
            </Content>
          </Tile>
        </GridItem>
      </GridContainer>
    </div>
  )
}
